import { temAcesso } from '@/shared/auth/temAcesso'

const Relatorios = () => import('./Relatorios.vue')
const PorCapa = () => import('./PorCapa.vue')
const PorPendencias = () => import('./PorPendencias.vue')


export default {
    path: '/gescon/relatoriosconvenios',
    name: 'Gescon_Relatorios_Convenios',
    component: Relatorios,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CONV-REL-00')) {
            next()
        }
    },
    children: [
        {
            path: 'porcapa',
            name: 'Gescon_Relatorios_Convenios_PorCapa',
            component: PorCapa,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONV-REL-04')) {
                    next()
                }
            }
        },
        {
            path: 'pendencias',
            name: 'Gescon_Relatorios_Convenios_PorPendencias',
            component: PorPendencias,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CONV-REL-04')) {
                    next()
                }
            }
        }
    ]
}
